import React from "react";
import { Result, Button, Typography, theme } from "antd";
import { ToolOutlined } from "@ant-design/icons";
import { RefreshCcw } from "lucide-react";

const { Text } = Typography;

const ServiceMaintenance = () => {
  const { token } = theme.useToken();

  const handleRefresh = () => {
    localStorage.clear();
    window.location.reload()
  };
  return (
    <div
     className="h-dvh flex justify-center items-center flex-col text-center p-4"
      style={{
        backgroundColor: token.colorBgLayout
      }}
    >
      <Result
        icon={<ToolOutlined style={{ color: token.colorPrimary, fontSize: 80 }} />}
        title="We'll be right back!"
        subTitle={
          <Text type="secondary" style={{ fontSize: 16 }}>
            Our system is currently undergoing scheduled maintenance.  
            <br />
            Please check back in a few minutes.
          </Text>
        }
        extra={
          <Button
            icon={<RefreshCcw className="!size-4" />}
            type="primary"
            onClick={() => handleRefresh()}
          >
            Refresh Page
          </Button>
        }
      />
      <Text type="secondary" style={{ marginTop: 24 }}>
        © {new Date().getFullYear()} Authnull Systems. All rights reserved.
      </Text>
    </div>
  );
};

export default ServiceMaintenance;
